import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class ExpanderComponent extends Component {
  init() {
    this.button = this.element.querySelector('.expander__button')
    this.region = this.element.querySelector('.expander__content-container')

    if (!this.button || !this.region) {
      return
    }

    this.button.addEventListener('click', () => this.toggleRegion())
    document.addEventListener('expander:opened', event => this.automaticClosing(event))
  }

  automaticClosing(event) {
    if (event.detail.source === this) {
      return
    }
    const sourceAccordion = event.detail.accordion
    const thisAccordion = this.element.closest('.article-accordeon')

    if (sourceAccordion && sourceAccordion.dataset.disableAutoClose) {
      return
    }

    if (!sourceAccordion || sourceAccordion !== thisAccordion) {
      return
    }

    if (this.button.getAttribute('aria-expanded') === 'true') {
      this.closeExpander()
    }
  }

  toggleRegion() {
    if (!this.button || !this.region) {
      return
    }

    if (this.button.getAttribute('aria-expanded') === 'true') {
      this.closeExpander()
    } else {
      this.openExpander()
    }
  }

  openExpander() {
    this.region.removeAttribute('hidden')
    this.region.removeAttribute('inert')
    this.button.setAttribute('aria-expanded', true)
    this.element.classList.add('expander--expanded')

    const accordionParent = this.element.closest('.article-accordeon')

    const openEvent = new CustomEvent('expander:opened', {
      bubbles: true,
      detail: {
        source: this,
        accordion: accordionParent,
      },
    })
    this.element.dispatchEvent(openEvent)
  }

  closeExpander() {
    this.region.setAttribute('hidden', 'hidden')
    this.region.setAttribute('inert', 'inert')
    this.button.setAttribute('aria-expanded', false)
    this.element.classList.remove('expander--expanded')
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'expander', ExpanderComponent))
